import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";

interface MenuSliderProps {
  pages: string[];
}

const MenuSlider: React.FC<MenuSliderProps> = ({ pages }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "center",
    skipSnaps: false,
    dragFree: false,
  });

  const [selectedIndex, setSelectedIndex] = useState(0);

  const scrollPrev = useCallback(() => {
    emblaApi?.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    emblaApi?.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);

    return () => {
      emblaApi.off("select", onSelect);
    };
  }, [emblaApi, onSelect]);

  return (
    <div className="menu-slider">
      <button
        className="slider-arrow left"
        onClick={scrollPrev}
        disabled={selectedIndex === 0}
      >
        &#10094;
      </button>

      <div className="embla" ref={emblaRef}>
        <div className="embla__container">
          {pages.map((page, index) => (
            <div className="embla__slide" key={index}>
              <img src={page} alt={`Menu ${index + 1}`} loading="lazy" />
            </div>
          ))}
        </div>
      </div>

      <button
        className="slider-arrow right"
        onClick={scrollNext}
        disabled={selectedIndex === pages.length - 1}
      >
        &#10095;
      </button>

      <div className="page-count">
        {selectedIndex + 1} / {pages.length}
      </div>
    </div>
  );
};

export default MenuSlider;
